// @flow
import { gray200 } from './constants/color'

export type BorderRadius = 0 | 2 | 4 | 8 | 16 | '50%'

export const smallRadius: BorderRadius = 2
export const mediumRadius: BorderRadius = 4
export const largeRadius: BorderRadius = 8
export const xlargeRadius: BorderRadius = 16
export const roundRadius: BorderRadius = '50%'

export const normalWidth = '1px'

type BorderOptions = {
  color?: string,
  radius?: BorderRadius,
  width?: string,
}

const border = (options: BorderOptions = {}) => ({
  borderWidth: options.width != null ? options.width : normalWidth,
  borderColor: options.color != null ? options.color : gray200,
  borderRadius: options.radius != null ? options.radius : undefined,
  borderStyle: 'solid',
})

border.y = (options: BorderOptions = {}) => ({
  ...border({ ...options, radius: 0 }),
  borderWidth: `${normalWidth} 0`,
})

border.top = (options: BorderOptions = {}) => ({
  ...border({ ...options, radius: 0 }),
  borderWidth: `${options.width != null ? options.width : normalWidth} 0 0 0`,
})

border.bottom = (options: BorderOptions = {}) => ({
  ...border({ ...options, radius: 0 }),
  borderWidth: `0 0 ${normalWidth} 0`,
})

border.left = (options: BorderOptions = {}) => ({
  ...border({ ...options, radius: 0 }),
  borderWidth: `0 0 0 ${normalWidth}`,
})

border.right = (options: BorderOptions = {}) => ({
  ...border({ ...options, radius: 0 }),
  borderWidth: `0 ${normalWidth} 0 0`,
})

border.round = (radius?: BorderRadius) => ({
  borderRadius: radius != null ? radius : mediumRadius,
})

border.inset = (color: string) => ({
  boxShadow: `inset 0 0 0 1px ${color}`,
})

export default border



// WEBPACK FOOTER //
// ./src/style/border.js